import {LOAD_AUCTION_LOCATIONS} from "../actions/dispatchTypes";

export default function locationsReducer(state = [], action) {
    switch (action.type) {
        case LOAD_AUCTION_LOCATIONS:
            return action.payload.items || state;
        default:
            return state;
    }
}